import { SAButton } from '@saux/design-system-react';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateBatchType } from '../../store/action-creators/adjusterActionCreator';
import { bulkRemoveAdjuster } from '../../store/actions/conversationActions';
import { CANCEL, REMOVE } from '../../utils/constants';
import { simpleGTMDataLayer } from '../../utils/utilities';
import DashboardAPIResponsePage from '../dashboardAPIResponsePage/DashboardAPIResponsePage';

export default function RemoveAdjuster(props: any) {
    const [isLoading, setLoading] = useState(false);
    const [isRemoveAPICalled, setRemoveAPICalled] = useState(false);
    const user = useSelector((state: any) => state.user);
    const dispatch = useDispatch();

    const getSuccessText = () => {
        return `You have successfully started the remove process for [${props.count}] conversations`;
    }

    // const getErrorText = () => {
    //     return `Cannot Remove from yourself [${failedConversations}] conversations beacuse you are the last adjuster on the conversation`
    // }

    const handleRemove = () => {
        props?.setConversationsEmpty()
        dispatch(updateBatchType(REMOVE));
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-Remove-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Confirmed Remove Action for Conversations`,
            event_value: `Confirmed Remove action triggered by ${user.fullName}`
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-Remove-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Confirmed Remove Action for Conversations`,
            event_value: `Confirmed Remove action triggered by ${user.fullName}`
        });

        //Conversations count Snowplow tag
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Select ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to Remove.`
          });
          simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Selected ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to Remove.`
          });
        
        const conversations = Object.values(props.selectedConversations)
            .map((con: any) => {
                return {
                    participantId: con.participantId,
                    conversationId: con.conversationId
                }
            });
        const batchUpdateConversationInput = { conversationParticipantIds: conversations, currentAdjusterId: user.email }
        setLoading(true);
        dispatch(bulkRemoveAdjuster(batchUpdateConversationInput, (res: any) => {
            // if (res.conversationIds && res.conversationIds.length > 0) {
            //     setFailedConversations(res.failed);
            // }
            setRemoveAPICalled(true);
            setLoading(false);
        }, (error: any) => {
            setLoading(false);
        }));
    }

    return (
        isLoading ?
            <div className="loader" /> :
            isRemoveAPICalled ?
                <DashboardAPIResponsePage
                    text={getSuccessText()}
                    selectedType={props.selectedType}
                    handleViewConversations={props.handleViewConversations}
                    selectedAction ={REMOVE}
                /> :
                <>
                    <div style={{ fontWeight: "bold" }}>[{props.count}] Conversations of {props?.selectedAdjuster?.adjusterName} Selected for Removal.</div>
                    <div style={{ fontWeight: "bold" }}> Do you wish to remove selected conversations?</div>
                    <div style={{ display: "flex", float: "right" }}>
                        <SAButton style={{ color: "black" }} label={CANCEL} variant="link-small" onClick={props.handleCancel} />
                        <SAButton style={{ color: "white", backgroundColor: "red", fontSize: 16 }} label={REMOVE} variant="small" onClick={handleRemove} />
                    </div>
                </>
    );
}
